import { DateString } from '../common/commonModels';

export enum ActionTypes {
  SET_SELECTED_DATE = 'setSelectedDate',
}

export interface SetSelectedDate {
  type: ActionTypes.SET_SELECTED_DATE;
  selectedDate: DateString;
}

export type Action = SetSelectedDate;

export const changeSelectedDate = (selectedDate: DateString): SetSelectedDate => ({
  selectedDate,
  type: ActionTypes.SET_SELECTED_DATE,
});
